import React, { useEffect, useState, useCallback } from 'react';
import { useSelector } from 'react-redux';

import { toast } from 'react-toastify';

import { isArray, isEmpty } from 'lodash';

import moment from 'moment';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { Input, DateTime, Hidden } from '~/components/Form';

import { validCharactersComAcentuados } from '~/helpers';

import { t } from '~/helpers';
import api from '~/services/api';

import { FormWrapper } from './styles';

import * as S from './styles';

import {
  KeyboardDateTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';


export default function MyForm({ data, reference, close, cancelarAcao }) {

  const [habDtaVencNotaFiscal, setHabDtaVencNotaFiscal] = useState(false);
  const [fatuDataFatura, setFatuDataFatura] = useState();

  const [pickerFatuDataFatura, setPickerFatuDataFatura] = React.useState(null);
  const [pickerFatuDataVencimento, setPickerFatuDataVencimento] = React.useState(null);


  //** */

  const { language } = useSelector((state) => state.user);

  // Modify format date and time component
  const formatDateTime = React.useMemo((time) => {
    if (language === 'pt-BR') {
      if (time) return 'DD/MM/YYYY HH:mm:ss';

      return 'DD/MM/YYYY';
    }

    if (time) return 'YYYY-MM-DD HH:mm:ss';

    return 'YYYY-MM-DD';
  }, [language]);

  //** */



  useEffect(() => {
    if (!isEmpty(fatuDataFatura)) {
      setHabDtaVencNotaFiscal(true);
      console.log(fatuDataFatura);
    } else {
      setHabDtaVencNotaFiscal(false);
    }

  }, [fatuDataFatura]);


  useEffect(() => {
    setHabDtaVencNotaFiscal(false);
  }, []);



  async function handleSubmit(param) {
    try {

      //pickerFatuDataFatura
      //pickerFatuDataVencimento


      if (data.fatu_data_envio_fatura === null) {
        toast.error('Data de envio da fatura inválida!');
        await cancelarAcao();
        return;
      }


      let fatu_data_faturadate = moment(param.fatu_data_fatura, "DD/MM/YYYY").format("YYYY/MM/DD");
      let fatu_data_vencimentodate = moment(param.fatu_data_vencimento, "DD/MM/YYYY").format("YYYY/MM/DD");

      if (pickerFatuDataFatura === null) {
        toast.error('É necessário infomar a data de envio da nota fiscal!');
        await cancelarAcao();
        return;
      }

      if (pickerFatuDataVencimento === null) {
        toast.error('É necessário infomar a data de vencimento da nota fiscal!!');
        await cancelarAcao();
        return;
      }

      //validações pickerFatuDataFatura
      let dataAtual = moment().format("YYYY-MM-DD");
      let dtnDigFatuDataFatura = moment(pickerFatuDataFatura, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD");
      let dtnFaturaDataEnvio = moment(data.fatu_data_envio_fatura, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD");
      if (moment(dtnDigFatuDataFatura).isAfter(dataAtual)) {        
        toast.error('Data de envio da nota fiscal maior que a data atual!');
        await cancelarAcao();
        return;
      }

      if (moment(dtnFaturaDataEnvio).isAfter(dtnDigFatuDataFatura)) {
        toast.error('Data de envio da nota fiscal maior que a data da fatura!');
        await cancelarAcao();
        return;
      }


      //validações pickerFatuDataVencimento      
      let dtnDigFatuFatuDataVencimento = moment(pickerFatuDataVencimento, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD");
      
      if (moment(dtnDigFatuDataFatura).isAfter(dtnDigFatuFatuDataVencimento)) {
        toast.error('Data de vencimento da nota fiscal menor que a data envio da nota fiscal!');
        await cancelarAcao();
        return;
      }

      let sparam = {
        ...param,
        fatu_data_fatura: fatu_data_faturadate,
        fatu_data_vencimento: fatu_data_vencimentodate,
      }


      const schema = Yup.object().shape({

        fatu_nota_fiscal: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .trim()
          .nullable(true)
          .min(1, t('s.geral.validacao.tamanhominimo').replace('%s', 1))
          .max(20, t('s.geral.validacao.tamanhomaximo').replace('%s', 20)),
        // .test(
        //   'characters-invalid',
        //   t('s.configuracao.geral.naopodecontercaracterespecial'),
        //   function (value) {
        //     return validCharactersComAcentuados(value);
        //   }
        // ),
        // fatu_data_fatura: Yup.date()
        //   .typeError('Data invalida')
        //   .nullable('Data invalida')
        //   // ANTIGO.transform(value => (isNaN(value) ? undefined :  moment(param.fatu_data_fatura , "DD/MM/YYYY").format("YYYY/MM/DD")))
        //   //.min(new Date(data.fatu_data_envio_fatura), `Data invalida, deve ser maior que ${data.fatu_data_envio_fatura} `)
        //   .min(moment(new Date(data.fatu_data_envio_fatura)).format("YYYY-MM-DD"), `Data invalida, deve ser maior que ${data.fatu_data_envio_fatura} `)

        //   .max(new Date(), `Data invalida, deve ser menor que ${new Date()} `)
        //   .required(t('s.geral.validacao.campoobrigatorio')
        //   ),
        // fatu_data_vencimento: (fatu_data_faturadate) ? Yup.date()
        //   .typeError('Data invalida')
        //   .nullable('Data invalida')
        //   .min(new Date(fatu_data_faturadate), `Data invalida, deve ser maior que ${fatu_data_faturadate} `)          
        //   .required(t('s.geral.validacao.campoobrigatorio'))
        //   : Yup.string()
        //     .required(t('s.geral.validacao.campoobrigatorio'))
        // ,
      });
      await schema.validate(sparam, {
        abortEarly: false,
      });


      //pickerFatuDataFatura
      //pickerFatuDataVencimento

      const objSend = {
        fatu_codigo: param.fatu_codigo,
        fatu_nota_fiscal: param.fatu_nota_fiscal,
        //fatu_data_fatura: pickerFatuDataFatura,
        //fatu_data_vencimento: pickerFatuDataVencimento,
        fatu_data_fatura: moment(pickerFatuDataFatura, 'YYYY-MM-DD HH:mm:ss', true).format('DD/MM/YYYY'),
        fatu_data_vencimento: moment(pickerFatuDataVencimento, 'YYYY-MM-DD HH:mm:ss', true).format('DD/MM/YYYY'),
        
        fatu_data_envio_fatura: moment(dtnFaturaDataEnvio, 'YYYY-MM-DD', true).format('DD/MM/YYYY'),
      };


      await api.put('radadmdadosfaturamentounidata/incluinumerornotafiscalfatura', objSend);


      toast.success(t('s.geral.sucessoalteracao'));

      await close();
    } catch (err) {

      await cancelarAcao();

      if (isArray(err)) {
        err.map((e) => toast.error(e));
      }

      const validationErrors = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });

        reference.current.setErrors(validationErrors);
      }
    }
  }

  useEffect(() => {

    let obj = {
      ...data,
      fatu_data_fatura: null,
    };


    reference.current.setData(obj);
  }, []);

  const handleSetValue = useCallback((field, value) => {
    reference.current.setFieldValue(field, value);
  }, []);


  //moment(fatuDataFatura, 'DD/MM/YYYY HH:mm:ss', true).format('YYYY-MM-DD HH:mm:ss')

  // Change date
  const handleChangeDataFatuDataFatura = React.useCallback((value) => {
    console.log(value);
    setPickerFatuDataVencimento(null);
    setPickerFatuDataFatura(value);
    let dataAtual = moment().format("YYYY-MM-DD");
    let dtnDig = moment(value, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD");
    let dtnFatura = moment(data.fatu_data_envio_fatura, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD")

    if (moment(dtnDig).isAfter(dataAtual)) {
      setFatuDataFatura(undefined);
      console.log('Data maior que a data atual!');
      return;
    }

    //A data digita nao pode ser menor que a data da fatura
    if (moment(dtnDig).isSameOrAfter(dtnFatura)) {
      if (value !== null) {
        setFatuDataFatura(value)
      } else {
        setFatuDataFatura(undefined);
      }
      console.log('Data maior');
    } else {
      setFatuDataFatura(undefined)
    }
    //handleSetValue('fatu_data_fatura', dtnDig);
    console.log(data);
  }, []);

  // Accept date
  const handleAcceptDataFatuDataFatura = React.useCallback((value) => {
    //console.log(value);
    // let data =  value.set({ seconds: 0 }).format('DD/MM/YYYY HH:mm:ss')
    console.log(data)
  }, []);




  const handleChangeDataFatuDataVencimento = React.useCallback((value) => {
    console.log(value);
    //let data =  moment(value, 'YYYY-MM-DD HH:mm:ss', true).format('DD/MM/YYYY');
    setPickerFatuDataVencimento(value);

    let dataAtual = moment().format("YYYY-MM-DD");
    let dtnDig = moment(value, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD");
    let dtnFaturaEnvio = moment(data.fatu_data_envio_fatura, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD");
    let dtnDigFatura = moment(fatuDataFatura, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD");
    console.log(data);
  }, []);

  // Accept date
  const handleAcceptDataFatuDataVencimento = React.useCallback((value) => {
    console.log(value);
    // let data =  value.set({ seconds: 0 }).format('DD/MM/YYYY HH:mm:ss')
    console.log(data)
  }, []);



  return (
    <>

      <S.Wrapper>

        <FormWrapper ref={reference} initialData={data} onSubmit={handleSubmit}>

          <Input
            name="fatu_codigo"
            label="Número da Pré-Fatura:"
            disabled
          />

          <Input
            name="fatu_numero_pedido"
            label="Número do Pedido:"
            disabled
          />

          <Input
            name="orga_nome"
            label="Órgão:"
            disabled
          />

          <Input
            name="fatu_nota_fiscal"
            label="Nota Fiscal:"
          />

          <Hidden name="fatu_data_fatura" />

          <KeyboardDatePicker
            name="fatuDataFatura"
            label='Data de Envio da Nota Fiscal:'
            ampm={false}

            disablePast={false}
            disableFuture={true}
            minDate={moment( data.fatu_data_envio_fatura !== null? data.fatu_data_envio_fatura: new moment() , "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD")}

            fullWidth
            value={pickerFatuDataFatura}
            onChange={handleChangeDataFatuDataFatura}
            format={formatDateTime}
            inputVariant="outlined"
            size="small"
            onAccept={handleAcceptDataFatuDataFatura}

            minDateMessage={`A data não pode ser menor que a data do envio da fatura! ${moment(data.fatu_data_envio_fatura, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY")} `}
            maxDateMessage="A data não pode ser maior que a data atual!"
            invalidDateMessage={'Data inválida!'}

          //onError={(err) => setInputError(err === 'Invalid Date Format')}
          />


          {/* <DateTime
            //time            
            nullable
            allowKeyboardControl={true} //Foi incluido novo... vai saber de tudo?????           

            name="fatu_data_fatura"
            label='Data de Envio da Nota Fiscal:'
            disablePast={false}
            disableFuture={true}
            minDateMessage="Data inválida!"
            maxDateMessage="Data inválida!"
            minDate={moment(data.fatu_data_envio_fatura, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD")}
            //minDate={data.fatu_data_envio_fatura}
            serialize={(value) =>
              value.set({ seconds: 0 }).format('DD/MM/YYYY HH:mm:ss')
            }
            getValue={
              (value) => {
                // let dtnDig = moment(value, "DD/MM/YYYY HH:mm:ss").format("DD/MM/YYYY");
                // let dtnFatura = moment(data.fatu_data_envio_fatura, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY")

                let dtnDig = moment(value, "DD/MM/YYYY HH:mm:ss").format("YYYY-MM-DD");
                let dtnFatura = moment(data.fatu_data_envio_fatura, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD")

                handleSetValue('fatu_data_vencimento', undefined);

                if (moment(dtnDig).isSameOrAfter(dtnFatura)) {
                  if (value !== null) {
                    setFatuDataFatura(value)
                  } else {
                    setFatuDataFatura(undefined);
                  }
                  console.log('Data maior');
                } else {
                  setFatuDataFatura(undefined)
                }
              }
            }
          /> */}


          {(habDtaVencNotaFiscal) && (

            <KeyboardDatePicker
              name="fatuDataVencimento"
              label='Data de Vencimento da Nota Fiscal:'
              ampm={false}

              disablePast={false}
              disableFuture={false}
              minDate={moment(pickerFatuDataFatura, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD")}

              fullWidth
              value={pickerFatuDataVencimento}
              onChange={handleChangeDataFatuDataVencimento}
              format={formatDateTime}
              inputVariant="outlined"
              size="small"
              onAccept={handleAcceptDataFatuDataVencimento}

              minDateMessage={`A data não pode ser menor que a data de envio da nota fiscal! ${moment(pickerFatuDataFatura, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY")} `}
              //minDateMessage="A data não pode ser menor que a data de envio da nota fiscal!"
              maxDateMessage="A data não pode ser maior que a data atual!"
              invalidDateMessage={'Data inválida!'}

            //onError={(err) => setInputError(err === 'Invalid Date Format')}
            />

            // <DateTime
            //   name="fatu_data_vencimento"
            //   label='Data de Vencimento da Nota Fiscal:'
            //   disablePast={false}
            //   disableFuture={false}
            //   invalidLabel={'TESTE'}
            //   minDateMessage="Data inválida!"
            //   maxDateMessage="Data inválida!"
            //   minDate={moment(fatuDataFatura, 'DD/MM/YYYY HH:mm:ss', true).format('YYYY-MM-DD HH:mm:ss')}
            //   serialize={(value) =>
            //     value.set({ seconds: 0 }).format('DD/MM/YYYY HH:mm:ss')
            //   }
            //   getValue={
            //     (value) => {

            //       let dtnDig = moment(value, "DD/MM/YYYY HH:mm:ss").format("YYYY-MM-DD");
            //       let dtnFatura = moment(fatuDataFatura, "DD/MM/YYYY HH:mm:ss").format("YYYY-MM-DD");

            //       if (moment(dtnDig).isSameOrAfter(dtnFatura)) {
            //         console.log('Data maior');
            //       } else {
            //         console.log('Data menor');
            //         handleSetValue('fatu_data_vencimento', undefined);
            //       }

            //     }
            //   }
            // />



          )}

        </FormWrapper>
      </S.Wrapper>
    </>
  );
}

MyForm.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  close: PropTypes.func.isRequired,
};
